export default __webpack_public_path__ + "8036cc8dd8950516a0cf542b84bc8220.svg";